'use strict';

export default function SiteService($http) {
  return {
    create: create,
    fetchAll: fetchAll,
    update: update
  };

  function fetchAll() {
    return $http.get('/sites.json');
  }

  function create(site) {
    return $http.post('/sites', { site: site });
  }

  function update(site) {
    return $http.patch('/sites/' + site.id, { site: site });
  }
}

SiteService.$inject = ['$http'];
